'use strict';

app.config(function ($popupProvider) {

  $popupProvider.define('survey', function () {
    return /*@ngInject*/ {
      windowClass: 'survey-modal',
      templateUrl: '/app/states/module/survey/survey.html'
    };
  });

});
